"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "Ok, so to begin can you please write down your worst case prediction about the future? This is the thought that’s driving your stress.",
  type: "multiWithOther",
  meta: {
    answerLabel: "The worst thing that could happen is",
    summaryTitle: "Your unhelpful thought was…"
  },
  options: ["I’ll lose someone important to me", "I’ll run out of money and go broke", "I’ll lose all my friends or family", "I’ll lose my job or fail my education", "I’ll end up homeless", "Everyone will reject or abandon me", "I’ll end up permanently depressed or hopeless", "Other"],
  batteryId: "RETRAINING_THINKING_STRESS"
}, {
  prompt: "Next, what are the reasons why the worst case prediction isn’t likely to happen?",
  type: "multiWithOther",
  meta: {
    answerLabel: "It’s not likely because",
    summaryTitle: "Your unhelpful thought was…"
  },
  options: ["The situation will probably change soon so that it’s less likely", "The realistic chances of it happening are very low", "Several bad things have to happen in sequence and that’s not likely", "I have strengths that I can use that will make it less likely", "I can ask people for support", "Other"],
  batteryId: "RETRAINING_THINKING_STRESS"
}, {
  prompt: "It can help if you recall a time when you were convinced something bad would occur but it never happened. Can you finish this sentence: Previously, I was convinced that a worst case situation was going to happen like...",
  type: "textarea",
  meta: {
    answerLabel: "Worst case situation was going to happen like",
    summaryTitle: "The reasons why the thought isn’t 100% true are:"
  },
  batteryId: "RETRAINING_THINKING_STRESS"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;